/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Webhooks20(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Webhooks20',
      'aria-hidden': true,
      focusable: false,
      width:  20 * scale,
      height: 20 * scale,
      viewBox: '0 0 20 20',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M13.96 4.978A4 4 0 1 0 6.532 7.5l.866-.5a3 3 0 1 1 4.098 1.098l-.433.25 2.989 5.176a1.5 1.5 0 1 0 .866-.5l-2.505-4.337a4 4 0 0 0 1.549-3.71zM8.496 5.5c0 .372.136.713.36.976l-2.504 4.337A4 4 0 1 0 8.264 16.5l-.866-.5a3 3 0 1 1-1.113-4.107l.448.259 2.989-5.177A1.5 1.5 0 1 0 8.495 5.5zm7.475 12.923A4 4 0 0 1 11.221 15H6.215a1.5 1.5 0 1 1 0-1h5.975v.521a3 3 0 1 0 3-3.021v-1a4 4 0 0 1 .78 7.923z","fill":"currentColor"}))
}
